import script from "./MenuModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuModal.vue?vue&type=script&setup=true&lang=js"

import "./MenuModal.vue?vue&type=style&index=0&id=277d4310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277d4310"]])

export default __exports__